import { useTranslation } from "react-i18next";
import { toast } from "sonner";

interface CopyToClipboardParams {
  value: string;
  successMessage?: string;
  errorMessage?: string;
}

const useCopyToClipboard = (): ((
  params: CopyToClipboardParams,
) => Promise<void>) => {
  const { t } = useTranslation("editor-fast-channel");

  return async ({
    value,
    successMessage,
    errorMessage,
  }: CopyToClipboardParams): Promise<void> => {
    try {
      await navigator.clipboard.writeText(value);
      toast.success(successMessage ?? t("copyToClipboard"));
    } catch (error) {
      toast.error(errorMessage ?? t("copyToClipboardError"));
      console.error("Error copying to clipboard:", error);
    }
  };
};

export default useCopyToClipboard;
